import React from "react";
import { UseFormReturn } from "react-hook-form";

import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";
import PercentIcon from '@mui/icons-material/Percent';

import {
    CreateAndEditCouponModalProps
} from "./models";

import { t, Trans } from "@lingui/macro";
import { ZPlayFormField } from "commons/fields";
import * as Yup from "yup";
import { withUseFormHook, } from "@sinossi/mates-react-library";
import {ContentProducerService} from "services/content-producer-service";
import {CreateCouponRequest, EditCouponRequest} from "models/request";


const CreateAndEditCouponModalSchema = Yup.object().shape({
    discountCode: Yup.string().required(t({
        id: "caecm-discount-code-required-msg",
        message: "È necessario inserire un codice sconto per poter modificare il genere"
    })),
    discount: Yup.number()
    .typeError(t({
        id: "caecm-discount-type-msg",
        message: "Inserire un valore numerico"
    }))
    .required(t({
        id: "caecm-discount-required-msg",
        message: "È necessario inserire il valore del codice sconto per poter modificare il genere"
    }))
    .min(1, t({
        id: "caecm-discount-code-min--msg",
        message: "Inserire un valore maggiore di 0"
    }))
    .max(100, t({
        id: "caecm-discount-code-max-msg",
        message: "Il valore massimo è 100"
    })),
});

class CreateAndEditCouponModal extends React.Component<CreateAndEditCouponModalProps & UseFormReturn, {}>
{

    componentDidMount(){
        if(this.props.coupon){
            this.props.setValue("discountCode", this.props.coupon.code);
            this.props.setValue("discount", this.props.coupon.value);
        }
    }

    private onSubmit = (values: any) => {
        if(this.props.coupon){
            this.editCoupon(values);
        } else {
            this.createCoupon(values);
        }
    }

    private editCoupon = (values: any) => {

        let request: EditCouponRequest = {
          code: values.discountCode,
          value: values.discount
        }

        ContentProducerService.editCoupon(this.props.coupon!.id, request, this.props.editCouponCallback, this.props.editCouponErrorCallback)
    }

    private createCoupon = (values: any) => {

        let request: CreateCouponRequest = {
            code: values.discountCode,
            value: values.discount
        }

        ContentProducerService.createCoupon(request, this.props.createCouponCallback, this.props.createCouponErrorCallback);
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={() => this.props.closeModal()}
                color={process.env.REACT_APP_BACKGROUND_COLOR}
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>
                    {this.props.coupon? <Trans id="caecm-edit-title">Modifica coupon</Trans> : <Trans id="caecm-create-title">Crea coupon</Trans>}
                </DialogTitle>
                <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
                    <DialogContent>
                        <Typography mt={-2}>
                            <Trans id="caecm-coupon-name-label">Inserisci il nome del codice sconto e il valore percentuale.</Trans>
                        </Typography>
                        <ZPlayFormField
                            label={t({
                                id: "caecm-discount-code",
                                message: "Codice sconto"
                            })}
                            name="discountCode"
                            required={true}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}
                        />
                        <ZPlayFormField
                            label={t({
                                id: "caecm-discount",
                                message: "Sconto"
                            })}
                            name="discount"
                            required={true}
                            endAdornment={<PercentIcon fontSize="small"/>}
                            control={this.props.control}
                            formState={this.props.formState}
                            trigger={this.props.trigger}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={this.props.closeModal}>
                            <Trans id={"caecm-close-btn"}>
                                Annulla
                            </Trans>
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            type="submit"
                            disabled={this.props.formState.isSubmitting}>
                            {this.props.coupon ? <Trans id={"caecm-edit-btn"}>Modifica</Trans> : <Trans id={"ccm-create-btn"}>Aggiungi</Trans>}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }
}

export default withUseFormHook<{}>(CreateAndEditCouponModal, CreateAndEditCouponModalSchema, {});
